module.exports = __webpack_public_path__ + "img/Flag_of_Togo.152d8492.svg";